import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.RentForecast.RentForecastHeader.Title',
    defaultMessage: 'Forecast Rents',
  },
  createRentForecast: {
    id: 'App.RentForecast.RentForecastHeader.CreateRentForecast',
    defaultMessage: 'Create Rent Forecast',
  },
  newRentForecast: {
    id: 'App.RentForecast.NewRentForecast',
    defaultMessage: 'New Rent Forecast',
  },
  cardSaveLabel: {
    id: 'App.RentForecast.Card.Save.Label',
    defaultMessage: 'Save',
  },
  cardCancelLabel: {
    id: 'App.RentForecast.Card.Cancel.Label',
    defaultMessage: 'Cancel',
  },
  cardEditLabel: {
    id: 'App.RentForecast.Card.Edit.Label',
    defaultMessage: 'Edit',
  },
  name: {
    id: 'App.RentForecast.Name',
    defaultMessage: 'Name',
  },
  placeholder: {
    id: 'App.RentForecast.Placeholder',
    defaultMessage: 'Forecast Name...',
  },
  floorPlans: {
    id: 'App.RentForecast.FloorPlans',
    defaultMessage: 'Floor Plans',
  },
  bedsBaths: {
    id: 'App.RentForecast.BedsBaths',
    defaultMessage: 'Beds/Baths',
  },
  unitType: {
    id: 'App.RentForecast.RDUnitType',
    defaultMessage: 'RD Unit Type',
  },
  numUnits: {
    id: 'App.RentForecast.NumUnits',
    defaultMessage: '# of Units',
  },
  approvedValue: {
    id: 'App.RentForecast.ApprovedValue',
    defaultMessage: 'Approved {column}',
  },
  currentValue: {
    id: 'App.RentForecast.CurrentValue',
    defaultMessage: 'Current {column}',
  },
  totalIncome: {
    id: 'App.RentForecast.TotalIncome',
    defaultMessage: 'Total {column} Income',
  },
  proposedChange: {
    id: 'App.RentForecast.ProposedChange',
    defaultMessage: 'Proposed Change',
  },
  proposedChanges: {
    id: 'App.RentForecast.ProposedChanges',
    defaultMessage: 'Proposed Changes',
  },
  newValue: {
    id: 'App.RentForecast.NewValue',
    defaultMessage: 'New {column}',
  },
  newPotentialIncome: {
    id: 'App.RentForecast.NewPotentialIncome',
    defaultMessage: 'New {column} Potential Income',
  },
  actualRentSpread: {
    id: 'App.RentForecast.ActualRentSpread',
    defaultMessage: 'Actual Rent Spread',
  },
  actualRentSpreadTooltip: {
    id: 'App.RentForecast.ActualRentSpread.Tooltip',
    defaultMessage: 'The difference between Note Rent and Basic Rent',
  },
  proposedRentSpread: {
    id: 'App.RentForecast.ProposedRentSpread',
    defaultMessage: 'Proposed Rent Spread',
  },
  currentIncomeTooltip: {
    id: 'App.RentForecast.CurrentIncome',
    defaultMessage:
      'The Total Current Income is calculated by the Current amount X the # of Units',
  },
  newProposedAmountTooltip: {
    id: 'App.RentForecast.NewProposedAmount',
    defaultMessage:
      'The New Proposed amount is calculated by the Current amount X the Proposed Change',
  },
  newNoteRentAmountTooltip: {
    id: 'App.RentForecast.newNoteRentAmountTooltip',
    defaultMessage:
      //eslint-disable-next-line max-len
      'The New Note Rent amount is calculated by the New Basic Rent + the applicable Rent Spread for each floor plan',
  },
  newPotentialIncomeTooltip: {
    id: 'App.RentForecast.NewPotentialIncomeTooltip',
    defaultMessage:
      'The New Potential Income is calculated by the New Proposed amount X the # of Units',
  },
  createdForecast: {
    id: 'App.RentForecast.CreatedForecast',
    defaultMessage: 'Created Rent Forecast',
  },
  success: {
    id: 'App.RentForecast.Success',
    defaultMessage: 'Success',
  },
  error: {
    id: 'App.RentForecast.Error',
    defaultMessage: 'Error',
  },
  updatedForecast: {
    id: 'App.RentForecast.UpdatedForecast',
    defaultMessage: 'Updated Rent Forecast',
  },
  budgetSaved: {
    id: 'App.RentForecast.BudgetSaved',
    defaultMessage: 'Budget Saved Successfully!',
  },
  budgetProgressSaved: {
    id: 'App.RentForecast.BudgetProgressSaved',
    defaultMessage: 'Budget Progress has been saved.',
  },
  reviewRDBudget: {
    id: 'App.RentForecast.ReviewRDBudget',
    defaultMessage: 'Review RD Budget',
  },
  comments: {
    id: 'App.RentForecast.Comments',
    defaultMessage: 'Comments',
  },
  commentsGenerate: {
    id: 'App.RentForecast.Comments.Generate.Button',
    defaultMessage: 'Auto-Generate Narrative',
  },
  narrativeModalTitle: {
    id: 'App.RentForecast.Comments.Modal.Title',
    defaultMessage: 'Confirm Auto-Generation',
  },
  narrativeModalDescription: {
    id: 'App.RentForecast.Comments.Modal.Description',
    defaultMessage:
      'Confirming this action will auto-fill the narrative content ' +
      'using your company’s standard template.',
  },
  narrativeModalWarning: {
    id: 'App.RentForecast.Comments.Modal.Warning',
    defaultMessage:
      'This will override any existing content you have entered in the Comments field.',
  },
  review: {
    id: 'App.RentForecast.Review',
    defaultMessage: 'Review',
  },
  intacctHeader: {
    id: 'App.RentForecast.IntacctHeader',
    defaultMessage: 'Refresh from Intacct',
  },
  intacctBody: {
    id: 'App.RentForecast.IntacctBody',
    defaultMessage:
      'Refreshing will update all information with the latest data from Intacct.',
  },
  intacctWarningPart1: {
    id: 'App.RentForecast.IntacctWarningPart1',
    defaultMessage: 'Items labeled',
  },
  intacctWarningPart2: {
    id: 'App.RentForecast.IntacctWarningPart2',
    defaultMessage: '"Modified After Intacct Sync"',
  },
  intacctWarningPart3: {
    id: 'App.RentForecast.IntacctWarningPart3',
    defaultMessage:
      'must be updated in Intacct first. If they are not, any changes ' +
      'made in Fortress since the last refresh will be overwritten.',
  },
  intacctSuccess: {
    id: 'App.RentForecast.IntacctSuccess',
    defaultMessage: 'Data from Intacct has been updated.',
  },
  date: {
    id: 'App.RentForecast.Date',
    defaultMessage: 'Year (Actuals)',
  },
  datePlaceholder: {
    id: 'App.RentForecast.DatePlaceholder',
    defaultMessage: 'YYYY',
  },
  confirmModalTitle: {
    id: 'App.RentForecast.confirmModalTitle',
    defaultMessage: 'Discard Changes?',
  },
  cancel: {
    id: 'App.RentForecast.Cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'App.RentForecast.Confirm',
    defaultMessage: 'Discard Changes',
  },
  confirmOnly: {
    id: 'App.RentForecast.ConfirmOnly',
    defaultMessage: 'Confirm',
  },
  create: {
    id: 'App.RentForecast.Create',
    defaultMessage: 'Generate 3560-7',
  },
  save: {
    id: 'App.RentForecast.Save',
    defaultMessage: 'Save',
  },
  saveProgress: {
    id: 'App.RentForecast.SaveProgress',
    defaultMessage: 'Save Progress',
  },
  saveAndClose: {
    id: 'App.RentForecast.SaveAndClose',
    defaultMessage: 'Save and Close',
  },
  lastSaved: {
    id: 'App.RentForecast.LastSaved',
    defaultMessage: 'Last Saved',
  },
  reportGenerated: {
    id: 'App.RentForecast.reportGenerated',
    defaultMessage: 'Report has been generated.',
  },
  vacancyRate: {
    id: 'App.RentForecast.VacancyRate',
    defaultMessage: 'Vacancy Rate',
  },
  vacancyRateTooltip: {
    id: 'App.RentForecast.VacancyRateTooltip',
    defaultMessage:
      'The number of unoccupied units divided by the number of total units at the property.',
  },
  rentSpread: {
    id: 'App.RentForecast.RentSpread',
    defaultMessage: 'Proposed Rent Spread',
  },
  rentSpreadSub: {
    id: 'App.RentForecast.RentSpread.Subtitle',
    defaultMessage: '(All Floor Plans)',
  },
  rentSpreadTooltip: {
    id: 'App.RentForecast.RentSpreadTooltip',
    defaultMessage:
      'Rent spread is the difference between Note Rent and Basic Rent. ' +
      'Entering a value here applies it to all floor plans, overriding any existing values entered below.',
  },
  actual: {
    id: 'App.RentForecast.Actual',
    defaultMessage: 'Actual',
  },
  proposed: {
    id: 'App.RentForecast.Proposed',
    defaultMessage: 'Proposed',
  },
  utilityAllowance: {
    id: 'App.RentForecast.UtilityAllowance',
    defaultMessage: 'Utility Allowance',
  },
  rdBudgetFormTooltipProposedValue: {
    id: 'App.RentForecast.RDBudgetFormTooltipProposedValue',
    defaultMessage: 'Proposed Value:',
  },
  rdBudgetFormPartThreeEndingBalanceTooltipLine1: {
    id: 'App.RentForecast.RDBudgetFormPartThreeEndingBalanceTooltipLine1',
    defaultMessage:
      'Fortress auto-calculates the proposed value assuming there are no capital expenditures. This is determined as {actual} Actual Ending Balance + ({transferToReserveMonthlyRate} Transfer to Reserve Monthly Rate * 6 months).', // eslint-disable-line max-len
  },
  rdBudgetFormPartThreeEndingBalanceTooltipLine2: {
    id: 'App.RentForecast.RDBudgetFormPartThreeEndingBalanceTooltipLine2',
    defaultMessage:
      'If any capital expenditures are planned or posted after June, then manually adjust the amount as needed and provide a Comment.', // eslint-disable-line max-len
  },
  openUtilityAllowanceTableButton: {
    id: 'App.RentForecast.OpenUtilityAllowanceTableButton',
    defaultMessage: 'Utility Allowances',
  },
  residentLetter: {
    id: 'residentLetter',
    defaultMessage: 'Resident Letter',
  },
  authorizeSignatureBudgetAction: {
    id: 'App.RentForecast.AuthorizeSignature',
    defaultMessage: 'Authorize Signature(s)',
  },
  approveBudgetAction: {
    id: 'App.RentForecast.ApproveBudgetAction',
    defaultMessage: 'Approve Budget',
  },
  generateReportAction: {
    id: 'App.RentForecast.BudgetAction.GenerateReport',
    defaultMessage: 'Generate Report',
  },
  buildBudgetAction: {
    id: 'App.RentForecast.BudgetAction.BuildBudget',
    defaultMessage: 'Build Budget',
  },
  reportHistoryAction: {
    id: 'App.RentForecast.ReportHistoryAction',
    defaultMessage: 'Report History',
  },
  noPermissionAction: {
    id: 'App.RentForecast.budgetActions.NoPermission',
    defaultMessage: 'You do not have permissions to perform this action.',
  },
  noApproveBudgetAlreadyAction: {
    id: 'App.RentForecast.NoApproveBudgetAlreadyAction',
    defaultMessage: 'You cannot approve an already approved budget.',
  },
  approvedBannerInfo: {
    id: 'App.RentForecast.Banner.Info',
    defaultMessage:
      'Editing is disabled for approved budgets. ' +
      'Any changes must be managed through the proposed budget.',
  },
  budgetActions: {
    id: 'rentForecast.budgetActions',
    defaultMessage: 'Budget Actions',
  },
  proposedChangesModalBody: {
    id: 'App.RentForecast.ProposedChangesModalBody',
    defaultMessage:
      'Select whether you want the proposed changes to be based on a dollar amount or a percentage.',
  },
  proposedChangesModalWarning: {
    id: 'App.RentForecast.ProposedChangesModalWarning',
    defaultMessage:
      'Confirming this change will reset the forecast table, which may remove any proposed changes ' +
      "you've already entered.",
  },
  rdBudgetFormTooltipProposedAsCurrent: {
    id: 'App.RentForecast.RDBudgetForm.Formula.General.ProposeAsCurrent',
    defaultMessage: 'Proposed = Current Budget',
  },
  rdBudgetFormPartOneLessVacancyTooltipLine1: {
    id: 'App.RentForecast.RDBudgetFormPartOneLessVacancyTooltipLine1',
    defaultMessage:
      'Fortress automatically calculates the proposed value based on the projected rental income and vacancy rate.', // eslint-disable-line max-len
  },
  rdBudgetFormPartOneLessVacancyTooltipLine2: {
    id: 'App.RentForecast.RDBudgetFormPartOneLessVacancyTooltipLine2',
    defaultMessage:
      'This is determined as {proposedRentalIncome} Proposed Rental Income × {vacancyRate} Proposed/Actual Vacancy Rate.', // eslint-disable-line max-len
  },
  rdBudgetFormPartOneLessVacancyTooltipLine3: {
    id: 'App.RentForecast.RDBudgetFormPartOneLessVacancyTooltipLine3',
    defaultMessage:
      'To adjust this value, update the vacancy rate on the Forecast Rents screen, and the total will be recalculated automatically.', // eslint-disable-line max-len
  },
  rdBudgetrdBudgetFormTooltipManagementFeesNotConfigured: {
    id: 'App.RentForecast.RDBudgetFormTooltipManagementFeesNotConfigured',
    defaultMessage:
      'Management Fees not configured for year {year}. Please contact your admin for assistance.',
  },
  forecastDuplicateError: {
    id: 'App.RentForecast.DuplicateError',
    defaultMessage:
      'A budget with this name already exists for the selected year.',
  },
  intacctError: {
    id: 'App.RentForecast.IntacctError',
    defaultMessage:
      'Property or budget not found in Intacct. Please verify that both the property and ' +
      'budget are set up correctly.',
  },
  noBudgetDataAvailable: {
    id: 'App.RentForecast.NoBudgetDataAvailable',
    defaultMessage: 'No budget data is available for the selected budget year.',
  },
  part2line1: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line1',
    defaultMessage: 'Proposed = $60 per unit x 12 months',
  },
  part2line2: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line2',
    defaultMessage: 'Proposed = Actual × 2 × 1.05',
  },
  part2line3: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line3',
    defaultMessage: 'Proposed = # units x 160',
  },
  part2line4: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line4',
    defaultMessage: 'Proposed = (Actual × 2) × 1.05',
  },
  part2line7: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line7',
    defaultMessage: 'Proposed = $15,000',
  },
  part2line8: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line8',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget or Actual × 2 × 1.05)',
  },
  part2line10: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line10',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget or Actual × 2)',
  },
  part2line12: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line12',
    defaultMessage: 'Proposed = Actual × 2 × 1.05',
  },
  part2line13: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line13',
    defaultMessage: 'Proposed = Actual × 2 × 1.05',
  },
  part2line14: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line14',
    defaultMessage: 'Proposed = Actual × 2 × 1.05',
  },
  part2line15: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line15',
    defaultMessage: 'Proposed = Actual × 2 × 1.05',
  },
  part2line16: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line16',
    defaultMessage: 'Proposed = Actual × 2 × 1.05',
  },
  part2line19: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line19',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget × 1.04 or (Actual × 2) × 1.09)',
  },
  part2line21: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line21',
    defaultMessage:
      'Proposed = Whichever is greater of (Actual + 100 or Current Budget + 100)',
  },
  part2line22: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line22',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget or Actual)',
  },
  part2line23: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line23',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget or Actual)',
  },
  part2line24: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line24',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget or Actual)',
  },
  part2line25: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line25',
    defaultMessage:
      'Proposed = Whichever is greater of ((Actual × 2) x 1.05 + 5 per unit or Current Budget + 5 per unit)',
  },
  part2line26: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line26',
    defaultMessage: '$1,000',
  },
  part2line27: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line27',
    defaultMessage: 'Proposed = $600',
  },
  part2line28: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line28',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget or $3,000)',
  },
  part2line29: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line29',
    defaultMessage: 'Proposed = $175 × number of units',
  },
  part2line30: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line30',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget × 1.04 or (Actual × 2) × 1.08)',
  },
  part2line31: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line31',
    defaultMessage: 'Proposed = $40 × number of units',
  },
  part2line32: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line32',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget x 1.05 or (Actual x 2) x 1.09)',
  },
  part2line34: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line34',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget × 1.05 or Actual × 1.09)',
  },
  part2line36: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line36',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget or Actual)',
  },
  part2line37: {
    id: 'App.RentForecast.RDBudget.Formula.Part2.Line37',
    defaultMessage:
      'Proposed = Whichever is greater of (Current Budget × 1.05 or Actual × 1.09)',
  },
  part3line2: {
    id: 'App.RentForecast.RDBudget.Formula.Part3.Line2',
    defaultMessage: 'Proposed = Current Budget',
  },
  part2VarianceTooltip: {
    id: 'App.RentForecast.RDBudget.Formula.Default',
    defaultMessage:
      'Variance % is calculated as: (Proposed – Current) ÷ Current',
  },
  generateRDReportError: {
    id: 'App.RentForecast.RDBudget.GenerateError',
    defaultMessage: 'Could not generate report for RD Budget',
  },
  saveRDError: {
    id: 'App.RentForecast.RDBudget.SaveError',
    defaultMessage: 'Could not save budget. Try again later',
  },
  autoCalculationModalHeader: {
    id: 'App.RentForecast.RDBudgetFormAutoCalculationModalHeader',
    defaultMessage: 'Confirm Auto-Calculation',
  },
  autoCalculationModalBody1: {
    id: 'App.RentForecast.RDBudgetFormAutoCalculationModalBody1',
    defaultMessage:
      'Confirming this action will update the Proposed Budget values on Part II using your company’s business rules.',
  },
  autoCalculationModalBody2: {
    id: 'App.RentForecast.RDBudgetFormAutoCalculationModalBody2',
    defaultMessage:
      'You can review these rules in the tooltips next to each applicable value.',
  },
  autoCalculationModalWarning: {
    id: 'App.RentForecast.RDBudgetFormAutoCalculationModalWarning',
    defaultMessage: `This will override any existing Proposed Values that are entered on Part II.
      If you only want to update a single field, cancel and update it manually instead.`,
  },
  autoCalculationCancelButton: {
    id: 'App.RentForecast.RDBudgetFormAutoCalculationCancelButton',
    defaultMessage: 'Cancel',
  },
  autoCalculationConfirmButton: {
    id: 'App.RentForecast.RDBudgetFormAutoCalculationConfirmButton',
    defaultMessage: 'Confirm & Calculate',
  },
  autoCalculationButton: {
    id: 'App.RentForecast.RDBudgetFormAutoCalculationButton',
    defaultMessage: 'Auto-Calculate',
  },
  autoCalculationSuccess: {
    id: 'App.RentForecast.RDBudgetFormAutoCalculationSuccess',
    defaultMessage: 'Calculations have been completed.',
  },
  rdBudgetFormPartThreeBeginningBalanceTooltip: {
    id: 'App.RentForecast.RDBudgetFormPartThreeBeginningBalanceTooltip',
    defaultMessage:
      'Fortress auto-calculates the proposed value assuming there are no capital expenditures. ' +
      'This is determined as the Actual Ending Balance + (Transfer to Reserve Monthly Rate * 6 months). ' +
      // eslint-disable-next-line max-len
      'If any capital expenditures are planned or posted after June, then manually adjust the amount as needed and provide a Comment.',
  },
  autoCalculationPart3ModalHeader: {
    id: 'App.RentForecast.RDBudgetFormPart3AutoCalculationModalHeader',
    defaultMessage: 'Confirm Auto-Calculation',
  },
  autoCalculationPart3ModalBody: {
    id: 'App.RentForecast.RDBudgetFormPart3AutoCalculationModalBody',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Confirming this action will update the Proposed Budget values on Part III using your company’s business rules.',
  },
  autoCalculationPart3ModalWarning: {
    id: 'App.RentForecast.RDBudgetFormPart3AutoCalculationModalWarning',
    defaultMessage: `This will override any existing Proposed Values that are entered on Part III.
    If you only want to update a single field, cancel and update it manually instead.`,
  },
  autoCalculationPart3Success: {
    id: 'App.RentForecast.RDBudgetFormPart3AutoCalculationSuccess',
    defaultMessage: 'Calculations have been completed.',
  },
  commentInvalidCharacters: {
    id: 'App.RentForecast.CommentInvalidCharacters',
    defaultMessage: 'Characters < and > are not allowed.',
  },
  commentTooLong: {
    id: 'App.RentForecast.CommentTooLong',
    defaultMessage: 'Comment cannot exceed 65 characters.',
  },
  part3line1: {
    id: 'App.RentForecast.RDBudget.Formula.Part3Line1',
    defaultMessage:
      'Fortress auto-calculates the proposed value assuming there are no capital expenditures. ' +
      'This is determined as the Actual Ending Balance + (Transfer to Reserve Monthly Rate * 6 months). ' +
      // eslint-disable-next-line max-len
      'If any capital expenditures are planned or posted after June, then manually adjust the amount as needed and provide a Comment.',
  },
});

export default messages;
